import { PaneArea } from '../../../types/shared'
import XABCD, { IXABCDAttrs } from '../../canvas/xabcd'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IXABCDAttrs
type PartialAttrs = Partial<Attrs>

class XABCDCreator extends XABCD<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    // TODO pattern
    const width = this.model.scale.x.width(80)
    const height = this.model.scale.y.height(80)
    this.attrs.xx = startArea.x - width
    this.attrs.xy = startArea.y + height / 2
    this.attrs.ax = startArea.x - width / 2
    this.attrs.ay = startArea.y - height / 2
    this.attrs.bx = startArea.x
    this.attrs.by = startArea.y
    this.attrs.cx = startArea.x + width / 2
    this.attrs.cy = startArea.y - height / 2
    this.attrs.dx = startArea.x + width
    this.attrs.dy = startArea.y + height / 2

    setTimeout(() => {
      this.replaceMyself(XABCD.fromObject<XABCD>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default XABCDCreator
